import { render, staticRenderFns } from "./tenant-page.vue?vue&type=template&id=8c6d3760&scoped=true&"
import script from "./tenant-page.vue?vue&type=script&lang=js&"
export * from "./tenant-page.vue?vue&type=script&lang=js&"
import style0 from "./tenant-page.vue?vue&type=style&index=0&id=8c6d3760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6d3760",
  null
  
)

export default component.exports